import { render, staticRenderFns } from "./classical-attendant-resume-download.vue?vue&type=template&id=5503a321"
import script from "./classical-attendant-resume-download.vue?vue&type=script&lang=js"
export * from "./classical-attendant-resume-download.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports